import { render, staticRenderFns } from "./PlaceBadge.vue?vue&type=template&id=5ecde02d&scoped=true&lang=html&"
import script from "./PlaceBadge.vue?vue&type=script&lang=js&"
export * from "./PlaceBadge.vue?vue&type=script&lang=js&"
import style0 from "./PlaceBadge.vue?vue&type=style&index=0&id=5ecde02d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecde02d",
  null
  
)

export default component.exports